import * as React from "react";
import styled from "styled-components/native";

import Layout from "../components/common/Layout";
import { Divider, Space, Surface } from "../styled-component";
import Text from "../components/common/Text";
import { Clazz as ClazzType, User, Syllabus } from "../types";
import useAppContextRole from "../app-context/useAppContextRole";
import Card from "../components/common/Card";
import { Theme } from "../styles";

import ClazzCard, { ClazzCardElement } from "./ClazzCard";
import ClazzesListCard from "./ClazzesListCard";
import ClazzSyllabusCard from "./ClazzSyllabusCard";
import useListClazzes from "../hooks/clazzes/useListClazzes";
import useListSyllabi from "../hooks/syllabi/useListSyllabi";
import useListClazzSyllabi from "../hooks/clazzes/useListClazzSyllabi";

export interface ClazzesLayoutProps {
  clazzId?: ClazzType["id"];
}

const Container = styled(Layout.Column)`
  background: ${Theme.colors.backgroundInfo};
`;

function ClazzesLayout({}: ClazzesLayoutProps) {
  const [clazzId, setClazzId] = React.useState<ClazzType["id"]>();
  const [syllabusId, setSyllabusId] = React.useState<Syllabus["id"]>();
  const [learnerId, setLearnerId] = React.useState<User["id"]>();
  const [role] = useAppContextRole();
  const { data: clazzes } = useListClazzes();
  const { data: syllabi } = useListClazzSyllabi(clazzId);
  const clazzCardRef = React.useRef<ClazzCardElement>(null);

  React.useEffect(() => {
    setClazzId(undefined);
  }, [role]);

  React.useEffect(() => {
    setSyllabusId(undefined);
    setLearnerId(undefined);
  }, [role, clazzId]);

  React.useEffect(() => {
    if (!clazzId && clazzes?.[0]) {
      setClazzId(clazzes[0].id);
    }
  }, [clazzId, clazzes]);

  React.useEffect(() => {
    if (!syllabusId && syllabi?.[0]) {
      setSyllabusId(syllabi[0].id);
    }
  }, [syllabusId, syllabi]);

  return (
    <Container greedy>
      <Space />

      <Layout.Row greedy>
        <Space />

        <ClazzesListCard
          greedy
          onPress={(item) => setClazzId(item.id)}
          isClazzSelected={(item) => item.id === clazzId}
        />

        <Space />

        {clazzId ? (
          <ClazzCard
            ref={clazzCardRef}
            greedy
            clazzId={clazzId}
            onPressSyllabus={(item) => setSyllabusId(item.id)}
            isSyllabusSelected={(item) => item.id === syllabusId}
            onPressLearner={(item) =>
              setLearnerId(learnerId ? undefined : item.id)
            }
            isLearnerSelected={(item) => item.id === learnerId}
          />
        ) : (
          <Card greedy>
            <Layout.Box size={1}>
              <Text textAlign="center">Select a Class</Text>
            </Layout.Box>
          </Card>
        )}

        <Space />

        {!!clazzId ? (
          !!syllabusId ? (
            <ClazzSyllabusCard
              greedy
              clazzId={clazzId}
              syllabusId={syllabusId}
              learnerId={learnerId}
              onPressLearner={() => {
                if (learnerId) {
                  setLearnerId(undefined);
                } else {
                  clazzCardRef.current?.setSelectedOption("roster");
                }
              }}
            />
          ) : (
            <Card greedy>
              <Layout.Box size={1}>
                <Text textAlign="center">Select a Syllabus</Text>
              </Layout.Box>
            </Card>
          )
        ) : (
          <Layout.Box greedy />
        )}

        <Space />
      </Layout.Row>

      <Space />
    </Container>
  );
}

export default ClazzesLayout;
